import React from 'react';
import './App.css';

// Simple Bar
import 'simplebar-react/dist/simplebar.min.css';

// Routes
import Index from './Routes';

// MUI
import { createTheme } from "@mui/material/styles";
import { CssBaseline } from '@mui/material';
// MUI
import { ThemeProvider } from '@mui/material/styles';


// Routes
import { createSelector } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";


// Fake Backend 
import fakeBackend from "./helpers/AuthType/fakeBackend";
import palette from './theme/palette';
import typography from './theme/typography';

// Activating fake backend
fakeBackend();

const modeData = createSelector(
  (state: any) => state.Layout,
  (modetype: any) => modetype.modetype
);

function App() {
  const mode = useSelector(modeData);

  const theme = createTheme({
    palette: palette(mode),
    typography,
  });

  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
        <CssBaseline />     
        <Index />
      </ThemeProvider>
    </React.Fragment>
  );
}

export default App;
